import { PureComponent } from 'react';
import styled from 'styled-components';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import AsyncNotInstalledAlert from '../../code-splitting/components/AsyncNotInstalledAlert';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import UIScriptloaderInstallModalPanel from 'ui-addon-scriptloader/UIScriptloaderInstallModalPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HideableChildren = styled.div.withConfig({
  displayName: "InstallCodePaneWrapper__HideableChildren",
  componentId: "sc-162096i-0"
})(["display:", ";flex-direction:column;"], ({
  hide
}) => hide ? 'none' : 'flex');
const OverflowUIBox = styled(UIBox).withConfig({
  displayName: "InstallCodePaneWrapper__OverflowUIBox",
  componentId: "sc-162096i-1"
})(["min-height:0;"]);
class InstallCodePaneWrapper extends PureComponent {
  constructor(...args) {
    super(...args);
    this.hideInstallCodeModalAndFetchStatus = () => {
      this.props.hideInstallCodePane();
      this.props.fetchInstallStatus();
    };
    this.renderPaneComponent = () => {
      return /*#__PURE__*/_jsx(UIScriptloaderInstallModalPanel, {
        onReject: this.hideInstallCodeModalAndFetchStatus,
        onConfirm: this.hideInstallCodeModalAndFetchStatus,
        showStatus: true
      });
    };
  }
  renderPaneOrAlert() {
    const {
      focusedThreadId,
      paneIsVisible
    } = this.props;
    if (paneIsVisible) {
      return this.renderPaneComponent();
    }
    if (focusedThreadId) {
      return /*#__PURE__*/_jsx(AsyncNotInstalledAlert, {
        threadId: focusedThreadId
      });
    }
    return null;
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      className: "width-100 height-100",
      children: /*#__PURE__*/_jsxs(UIFlex, {
        justify: "center",
        direction: "column",
        align: "stretch",
        className: "width-100 height-100",
        children: [this.renderPaneOrAlert(), /*#__PURE__*/_jsx(OverflowUIBox, {
          grow: 1,
          basis: "0",
          children: /*#__PURE__*/_jsx(HideableChildren, {
            className: "width-100 height-100",
            hide: this.props.paneIsVisible,
            children: this.props.children
          })
        })]
      })
    });
  }
}
InstallCodePaneWrapper.displayName = 'InstallCodePaneWrapper';
export default InstallCodePaneWrapper;